// show the work quota of the pastor
function showPlanningSubmissionPastorWorkQuota(pastorId) {
    if (pastorId != 'delta' && pastorId > 0) {
        $('.pastor-work-quota').show();
        $('.pastor-work-quota .pastor-work-quota-item').hide();
        $('.pastor-work-quota .pastor-work-quota-item[data-pastor-id="' + pastorId + '"]').show();
    } else {
        $('.pastor-work-quota').hide();
    }
}

// show the work time tables of the pastor
function showPlanningSubmissionPastorWorkTime(pastorId) {
    $('.pastor-work-time').hide();
    $('.pastor-work-time[data-pastor-id="' + pastorId + '"]').show();
}

const init = () => {
	$(document).ready(function() {
	    if ($('.planning-submissions-content .pastor-select').length) {
	        var pastorId = $('.planning-submissions-content .pastor-select').val();

	        showPlanningSubmissionPastorWorkQuota(pastorId);
	        showPlanningSubmissionPastorWorkTime(pastorId);
	    }

	    // planning submission: switch between Aufgaben- und Verantwortungsbereiche and Stellenbeschriebe
	    $('.planning-submissions-nav .nav-link').on('click', function(event) {
	        event.preventDefault();
	        $('.planning-submissions-nav .nav-link').removeClass('active');
	        $(this).addClass('active');
	        $('.planning-submissions-content').removeClass('active');
	        $($(this).attr('href')).addClass('active');
	    });

	    $('.pastor-select').on('change', function() {
	        var pastorId = $(this).val();

	        showPlanningSubmissionPastorWorkQuota(pastorId);
	        showPlanningSubmissionPastorWorkTime(pastorId);
	    });



	    // add church service
	    $('.add-church-service').on('click', function(e) {
	        e.preventDefault();
	        var container = $('.church-service-prototype-container');
	        var uuid = parseInt(Math.random() * Math.floor(9899) + 100);
	        var proto = container.data('prototype').replace(/__NAME__/g, uuid);
	        container.find('.church-service-container').append(proto);

	        container.find(`[name="churchServices[${uuid}][location]"]`).focus();
	    });

	    // remove church service
	    $(document).on('click', '.remove-church-service', function(){
	        var container = $(this).closest('.form-group');
	        container.remove();
	    });
	});
}

export default init;